<script setup lang="ts">
import { computed, defineProps, onMounted, RenderFunction } from 'vue'
import { KycDocumentVerificationStatus, KycDocumentVerificationType } from '../../../../typings'
import { PersonalAccountData } from '../../../../utilities/account/useAccountDataPersonal'
import AccountKycDocument from './AccountKycDocument.vue'
import { KycDocument } from '../../../../utilities/api'
import { LegalAccountData } from '../../../../utilities/account/useAccountDataLegal'
import AccountKycDocumentsUpload from './AccountKycDocumentsUpload.vue'

export interface KycDocumentSettings {
    header: string
    accepted?: boolean
    icon?: RenderFunction
    documents: KycDocument[]
}

const props = defineProps<{
    kycDocuments: KycDocumentSettings
    verificationType: KycDocumentVerificationType
    store: PersonalAccountData | LegalAccountData
}>()

const hasPendingKycDocuments = computed(
    () =>
        !!props.kycDocuments.documents.find(
            (kycDoc) => kycDoc.verification_status === KycDocumentVerificationStatus.IN_PROGRESS
        )
)

const showAddButton = computed(
    () =>
        props.verificationType === 'kyc_legal' ||
        (props.kycDocuments.documents.length > 0 && !hasPendingKycDocuments.value)
)
const newKycUploadOnInit = computed(() => props.kycDocuments.documents.length == 0)

function updateKycDocs() {
    props.store.fetchKycDocuments()
    props.store.fetchBankAccounts()
}
</script>

<template>
    <div>
        <template v-if="kycDocuments.documents.length > 0">
            <div class="mt-5 !space-y-4">
                <AccountKycDocument
                    v-for="(kycDoc, idx) in kycDocuments.documents"
                    :key="idx"
                    class="my-2"
                    :kyc-document="kycDoc"
                    :verification-type="verificationType"
                    :icon="kycDocuments.icon"
                    @updated-bank-account="updateKycDocs" />
            </div>
        </template>

        <AccountKycDocumentsUpload
            class="mt-4"
            :icon="kycDocuments.icon"
            :store="store"
            :new-kyc-upload-on-init="newKycUploadOnInit"
            :show-add-button="showAddButton"
            :verification-type="verificationType" />
    </div>
</template>
